export const FooterStyles = {
  footer: 'w-full flex justify-center h-22 bg-skyblue100',
  footerContent: 'flex flex-col w-full max-w-6xl',
}
